export const parseFieldRestrictions = (fieldRestrictions) => {
  if (!fieldRestrictions || typeof fieldRestrictions !== "object") return { immutableFields: [], hiddenFields: [] };
  const fieldsWithRestrictions = Object.keys(fieldRestrictions);
  if (!fieldRestrictions || fieldsWithRestrictions.length < 1) return { immutableFields: [], hiddenFields: [] };
  const getHidden = () => fieldsWithRestrictions.filter(
    (field) => fieldRestrictions[field].filter((restriction) => restriction.type === "hidden").length > 0
  );
  const getImmutable = () => fieldsWithRestrictions.filter(
    (field) => fieldRestrictions[field].filter((restriction) => restriction.type === "immutable").length > 0
  );
  return { immutableFields: getImmutable(), hiddenFields: getHidden() };
};
